module.exports = __webpack_public_path__ + "img/card-especies.78b60bb7.svg";